import { render, staticRenderFns } from "./MyProfileMarket.vue?vue&type=template&id=7f2bc397&scoped=true"
import script from "./MyProfileMarket.vue?vue&type=script&lang=js"
export * from "./MyProfileMarket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2bc397",
  null
  
)

export default component.exports